import { FlexIcon } from 'canoe';
import React from 'react';

import { ValueToggle } from '@candu-ai/craft/ui';

interface Props {
  flexDirection: string;
  setCss: (css: Record<string, any>) => void;
}

export const FlexDirectionRow = ({ flexDirection, setCss }: Props) => {
  return (
    <ValueToggle
      toggleGroup="flex-direction"
      data-cy="toolbox-flex-direction-row"
      onClick={() => setCss({ display: 'flex', flexDirection: 'row' })}
      isActive={flexDirection === 'row'}
      icon={FlexIcon}
      tooltip="Horizontal"
      color="light"
    />
  );
};
